<template>
  <filtertron-tray-section
    id="field-configurator-conditional"
    :title="lang.get('fields.configuration.conditional.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <conditional-config
        :field="field"
        :conditional-fields="conditionalFields"
        :conditionals="conditionals"
        @input="config => this.$emit('input', config)"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import ConditionalConfig from '@/lib/components/Fields/ConditionalConfig';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    ConditionalConfig,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', [
      'fields',
      'conditionalFieldTypes',
      'conditionals'
    ]),
    conditionalFields() {
      return this.fields
        .filter(field => field.id !== this.field.id)
        .filter(field => field.resource === this.field.resource)
        .filter(field => this.conditionalFieldTypes.includes(field.type));
    }
  }
};
</script>
